var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('SpansTable',_vm._g({staticClass:"mb-4",attrs:{"date-range":_vm.dateRange,"loading":_vm.spans.loading,"spans":_vm.spans.items,"order":_vm.spans.order,"pager":_vm.spans.pager,"is-span":_vm.isSpan}},_vm.listeners)),_c('XPagination',{attrs:{"pager":_vm.spans.pager}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }